<template>
  <div class="reimbursementPage" v-if="!this.showLoad">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.realName"
          v-if="mode != 'add'"
          readonly
          input-align="right"
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          class="ggInput"
          v-else
          input-align="right"
          readonly
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.departmentName"
          v-if="mode != 'add'"
          :required="editType"
          readonly
          input-align="right"
          label="申请部门："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.departmentName"
          class="ggInput"
          :required="editType"
          v-else
          input-align="right"
          readonly
          label="申请部门："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.reimburseUidName"
          label="报销人："
          :required="editType"
          readonly
          class="ggInput"
          input-align="right"
          @click="showPickerFun"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.createTime"
          class="ggInput"
          input-align="right"
          label="报销日期："
          readonly
        />
      </van-cell-group>

      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          placeholder="请选择"
          @click="checkItemPicker"
          :is-link="editType"
          readonly
          class="ggInput"
          input-align="right"
          rows="1"
          autosize
        />
      </van-cell-group>
      <div v-if="propertyData.projectName != ''">
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            :value="
              incomeAndExpenses.contractAmount != null
                ? incomeAndExpenses.contractAmount
                : 0
            "
            label="合同金额："
            readonly
            class="ggInput"
            input-align="right"
          />
        </van-cell-group>
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            v-model="incomeAndExpenses.expenses"
            label="项目支出："
            @click="
              parseFloat(incomeAndExpenses.expenses) > 0
                ? getMoneyDetail('expend')
                : ''
            "
            :is-link="parseFloat(incomeAndExpenses.expenses) > 0"
            readonly
            class="ggInput"
          />
        </van-cell-group>

        <div
          :class="[
            'projectIncome',
            incomeAndExpenses.contractAmount != null &&
            parseFloat(incomeAndExpenses.contractAmount) > 0 &&
            incomeAndExpenses.income != null &&
            parseFloat(incomeAndExpenses.income) > 0
              ? 'changeW'
              : '',
          ]"
        >
          <van-cell-group class="itemSite baseNone beizhu">
            <van-field
              v-model="incomeAndExpenses.income"
              label="项目到账："
              @click="
                parseFloat(incomeAndExpenses.income) > 0
                  ? getMoneyDetail('income')
                  : ''
              "
              readonly
              :is-link="parseFloat(incomeAndExpenses.income) > 0"
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketPercent"
              label="营销成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCost"
              label="营销成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCostTotal"
              label="累计营销已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainMarketingCost"
              label="剩余营销可支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technologyPercent"
              label="技术成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCost"
              label="技术成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCostTotal"
              label="累计技术已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainTechnicalCost"
              label="剩余技术可支出成本元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="bidCostTotal"
              label="累计投标成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionPercent"
              label="招待成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCost"
              label="招待成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCostTotal"
              label="累计已支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainReceptionCost"
              label="剩余可支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
        </div>
      </div>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.projectOrgan"
          clearable
          readonly
          class="ggInput"
          input-align="right"
          label="项目单位："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.remarks"
          rows="1"
          autosize
          label="备注："
          type="textarea"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="editType == true ? false : true"
        />
      </van-cell-group>
      <div class="claimDetailMain">
        <p class="fgx"></p>
        <p class="tit">报销明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in reimburseList"
              :key="item.typeCode"
            >
              <!-- <van-cell-group class="baseNone baseSalary">
                <van-field
                  v-model="item.typeName"
                  label="报销类型："
                  :required="editType"
                  readonly
                  class="ggInput"
                  input-align="right"
                  @click="showTypePickerFun(key)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>
               -->
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.firstTypeName"
                  label="报销类别："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showBxTypePickerFun(1, index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.secondTypeName"
                  label="二级类别："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showBxTypePickerFun(2, index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.thirdTypeName"
                  label="三级类别："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showBxTypePickerFun(3, index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>

              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.amount"
                  clearable
                  type="number"
                  v-enterIntNumber
                  :readonly="!editType"
                  :required="editType"
                  class="ggInput"
                  input-align="right"
                  label="金额："
                  :placeholder="editType ? '请输入...  ' : ''"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.instruction"
                  clearable
                  :readonly="!editType"
                  :required="editType"
                  label="报销说明："
                  class="ggInput"
                  input-align="right"
                  :placeholder="editType ? '请输入...  ' : ''"
                  type="textarea"
                  rows="1"
                  autosize
                />
              </van-cell-group>
              <div class="delect" v-if="reimburseList.length > 1 && editType">
                <van-icon name="cross" @click="delect(key)" />
              </div>
            </div>
          </div>
          <div class="addBtn" v-if="editType">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加报销明细</van-button
            >
          </div>
        </van-cell-group>
      </div>
      <van-cell-group class="baseNone baseSalary moreText dwBox">
        <van-field
          v-model="propertyData.receiptsNumber"
          clearable
          type="digit"
          :readonly="!editType"
          :required="editType"
          class="ggInput"
          input-align="right"
          label="单据张数（张）："
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="totalAmount"
          clearable
          class="ggInput"
          input-align="right"
          readonly
          label="报销总金额（元）："
        />
      </van-cell-group>
      <!-- 附件 -->
      <!-- <file-view
        :filesData="propertyData"
        :editType="editType"
        @changeFile="changebaseAnnexes"
        class="fileview"
      ></file-view> -->
      <!-- 微信的附件 避免和原生交互 -->
      <wx-file-view
        v-if="is_weixn"
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="propertyData"
        :editType="editType"
        @changeFile="changebaseAnnexes"
        class="fileview"
      ></file-view>
      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->

    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>

    <!-- 报销类型选数组-->
    <van-popup v-model="showBxTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="bxTypeListBase"
        value-key="dictName"
        @cancel="showBxTypePicker = false"
        @confirm="saveBxType"
      />
    </van-popup>
    <!-- 项目支出或收入明细 -->
    <van-popup
      v-model="showProjectMoneyPicker"
      round
      closeable
      close-icon="close"
      position="bottom"
      class="moneyPicker"
    >
      <ul v-if="moneydetailList.length != '0'">
        <li v-for="item in moneydetailList" :key="item.id">
          <div class="incomeInfo">
            <p>
              {{ pickerType == "income" ? "到账类型" : "支出类型" }}：{{
                item.typeName
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账时间" : "支出时间" }}：{{
                item.createTime
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账金额" : "支出金额" }}：{{
                item.amount
              }}元
            </p>
            <p>备注：{{ item.remarks }}</p>
          </div>
        </li>
      </ul>

      <div class="nonePage" v-if="moneydetailList.length == '0' && refreshing">
        <img :src="baseUrl + 'empty.png'" alt />
        <p>暂无数据</p>
      </div>
    </van-popup>
    <!-- 选择人员 -->
    <van-popup v-model="showPersonnelPicker" position="bottom" class="roleBox">
      <redio-retinue-view @setReview="setPersonnelMsg"></redio-retinue-view>
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const projectView = () => import("@/components/businessTripMould/projectView");
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const redioRetinueView = () =>
  import("@/components/businessTripMould/redioRetinueView");
export default {
  name: "reimbursement",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showPersonnelPicker: false,
      mode: "add",
      editType: false, //能否编辑
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      showItemPicker: false, //所属项目弹框
      showTypePicker: false, //类型弹出框
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      addType: false, //防止高频点击
      propertyData: {
        applicantIdName: "", //申请人名称
        departmentName: "", //申请部门
        reimburseUidName:'',//报销人名称
        reimburseUid:'',//报销人名称id
        createTime: "", //申请时间
        projectName: "", //所属项目名称
        projectCode: "", //所属项目code
        receiptsNumber: "", //单据张数
        projectOrgan: "", //项目单位
        remarks: "", //备注
        baseAnnexes: [], //附件
        verifyStatus: "hold",
      },
      marketPercent: "", //营销成本比例
      marketingCost: "", // 营销成本
      marketingCostTotal: "", // 累计营销成本
      marketArchive: true,//营销成本是否封存
      remainMarketingCost: "", //剩余营销成本
      technologyPercent: "", //技术成本比例
      technicalCost: "", // 技术成本
      technicalCostTotal: "", // 累计技术成本
      technologyArchive: true,//技术成本是否封存
      remainTechnicalCost: "", //剩余技术成本
      remainReceptionCost: "", //剩余招待费用
      receptionCostTotal: "", //累计已支出招待费
      receptionCost: "", //招待成本
      receptionPercent: "", //招待成本限额比例
      bidCostTotal: "", //累计投标成本
      showBxTypePicker: false,
      firstContact: [], //营销人员
      bxTypeList: [], //报销类型数组
      bxTypeIndex: 1,

      reimburseList: [
        //添加报销明细数组
        {
          firstType: "", //报销类型；一级码表
          firstTypeName: "", //一级码表name
          secondType: "", //报销类型；二级码表
          secondTypeName: "", //二级码表name
          thirdType: "", //报销类型；三级码表
          thirdTypeName: "", //三级码表name
          amount: 0,
          instruction: "",
        },
      ],
      incomeAndExpenses: {
        income: "",
        expenses: "",
        contractAmount: "", //合同金额
      },
      specialType: "", //判断普通报销与特殊属性
      typeColumns: [], //报销类型
      typeIndex: 0, //增加报销的index
      clientType: getDeviceType(),
      sendType: "",
      pickerType: "", //判断弹出框显示是支出还是收入
      showProjectMoneyPicker: false, //支出或收入详情弹框默认不显示
      moneydetailList: [], //支出或收入详情列表
      refreshing: false, //无数据显示
      is_weixn: is_wei(), //是否为微信
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "报销申请";
    }
    let time = dateFormat(new Date());
    this.$set(this.propertyData, "createTime", time);
    this.$set(this.propertyData, "applicantIdName", this.userinfo.realName);
    this.$set(
      this.propertyData,
      "departmentName",
      this.userinfo.departmentName
    );
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.specialType = this.$route.query.specialType; //1为普通报销 2为管理报销 判断普通报销与特殊属性
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
    this.typeColumns = await getDictList("baoxiao"); //字典项接口获取报销类型
    this.getBxType("bx", 1);
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    projectView,
    verifyMain,
    flowStaff,
    redioRetinueView,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    addClaim() {
      //添加报销明细函数
      this.reimburseList.push({
        firstType: "", //报销类型；一级码表
        firstTypeName: "", //一级码表name
        secondType: "", //报销类型；二级码表
        secondTypeName: "", //二级码表name
        thirdType: "", //报销类型；三级码表
        thirdTypeName: "", //三级码表name
        amount: "",
        instruction: "",
      });
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.propertyData.baseAnnexes = data;
    },
    //人员选择
    showPickerFun() {
      if (this.editType) {
        this.showPersonnelPicker = true;
      }
    },
    setPersonnelMsg(data) {
      //人员选择回调
      this.$set(this.propertyData, "reimburseUidName", data.realName);
      this.$set(this.propertyData, "reimburseUid", data.id);
      this.showPersonnelPicker = false;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.reimburse
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "操作成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    delect(index) {
      this.reimburseList.splice(index, 1);
    },

    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.finance.reimburse
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            this.firstContact = res.data.firstContact;
            _this.propertyData.createTime =
              _this.propertyData.createTime.substr(0, 10);
            if (_this.propertyData.remarks == null) {
              _this.$set(_this.propertyData, "remarks", "");
            }
            _this.$set(_this.propertyData, "projectCode", res.data.projectId);
            _this.reimburseList = _this.propertyData.detailResultList;
            _this.getIncomeAndExpenses(res.data.projectId); //获取项目的收支情况
            _this.specialType = res.data.reimburseType;
            _this.getCostInfo(res.data.projectId);
            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //  TimePicker() {
    //   this.showTimePicker = true;
    // },
    onTimeConfirm(data) {
      let time = dateFormat(data);
      this.showTimePicker = false;
      this.$set(this.propertyData, "createTime", time);
    },

    // saveType(data) {
    //   this.showTypePicker = false;
    //   this.$set(this.reimburseList[this.typeIndex], "typeName", data.dictName);
    //   this.$set(this.reimburseList[this.typeIndex], "type", data.dictCode);
    // },
    //获取报销类型列表
    getBxType(index, parentCode) {
      let _this = this;
      _this.$api.baseCommon.baseMsg.dictBox
        .enableItemList(parentCode)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let baseData = [];
            let baseList = res.data ? res.data : "";
            // if (parentCode == "bx" || this.specialType != "1") {
            //   _this.bxTypeList = baseList;
            // } else {
            if (this.specialType == "1") {
              if (index == "1") {
                baseList.forEach((item) => {
                  if (item.dictName == "营销成本" && !_this.marketArchive) {
                    if (this.firstContact && this.firstContact[0]) {
                      this.firstContact.forEach((userItem) => {
                        if (userItem == this.userinfo.id) {
                          baseData.push(item);
                        }
                      });
                    }
                  } else if (item.dictName == "项目技术成本") {
                    (this.isZL || this.userinfo.deptType == "jsbg" || this.userinfo.deptType == "tbbg") && !_this.technologyArchive
                      ? baseData.push(item)
                      : "";
                  } else if (item.dictName == "投标成本") {
                    this.userinfo.deptType == "tbbg" ? baseData.push(item) : "";
                  } else if (
                    item.dictName == "管理成本" &&
                    this.userinfo.deptType != "jsbg" &&
                    this.userinfo.deptType != "yxbg" && !this.isZL
                  ) {
                    baseData.push(item);
                  } else if (
                    item.dictName != "项目技术成本" &&
                    item.dictName != "营销成本" &&
                    item.dictName != "投标成本" &&
                    item.dictName != "管理成本"
                  ) {
                    baseData.push(item);
                  }
                });
                _this.bxTypeList = baseData;
              } else {
                _this.bxTypeList = baseList;
              }
              // if (this.firstContact && this.firstContact[0]) {
              //   this.firstContact.forEach((userItem) => {
              //     if (userItem == this.userinfo.id) {
              //       baseList.forEach((item) => {
              //         if (item.dictName == "营销成本") {
              //           baseData.push(item);
              //         }
              //       });
              //     } else {
              //       if (this.userinfo.deptType == "jsbg") {
              //         baseList.forEach((item) => {
              //           if (item.dictName == "项目技术成本") {
              //             baseData.push(item);
              //           }
              //         });
              //       } else if (this.userinfo.deptType == "tbbg") {
              //         baseList.forEach((item) => {
              //           if (
              //             item.dictName == "投标成本" ||
              //             item.dictName == "管理成本"
              //           ) {
              //             baseData.push(item);
              //           }
              //         });
              //       } else {
              //         baseList.forEach((item) => {
              //           console.log(item.dictName);
              //           if (
              //             item.dictName != "投标成本" &&
              //             item.dictName != "项目技术成本" &&
              //             item.dictName != "营销成本"
              //           ) {
              //             baseData.push(item);
              //           }
              //         });
              //       }
              //     }
              //   });
              // } else if (this.userinfo.deptType == "jsbg") {
              //   baseList.forEach((item) => {
              //     if (item.dictName == "项目技术成本") {
              //       baseData.push(item);
              //     }
              //   });
              // } else if (this.userinfo.deptType == "tbbg") {
              //   baseList.forEach((item) => {
              //     if (
              //       item.dictName == "投标成本" ||
              //       item.dictName == "管理成本"
              //     ) {
              //       baseData.push(item);
              //     }
              //   });
              // } else {
              //   baseList.forEach((item) => {
              //     if (item.dictName == "管理成本") {
              //       baseData.push(item);
              //     }
              //   });
              // }
              // _this.bxTypeList = baseData;
            } else {
              _this.bxTypeList = baseList;
            }
          }
          // }
        });
    },
    showBxTypePickerFun(typeIndex, index) {
      //打开类型选择弹窗
      if (!this.editType) {
        return false;
      }
      if (!this.propertyData.projectCode) {
        this.$toast("请先选择项目");
        return false;
      }
      if (typeIndex == "1") {
        this.getBxType(1, "bx");
      } else if (typeIndex == "2") {
        if (!this.reimburseList[index].firstType) {
          this.$toast("请选择上一级");
          return false;
        } else {
          this.getBxType(2, this.reimburseList[index].firstType);
        }
      } else {
        if (!this.reimburseList[index].secondType) {
          this.$toast("请选择上一级");
          return false;
        } else {
          this.getBxType(3, this.reimburseList[index].secondType);
        }
      }

      this.showBxTypePicker = true;
      this.typeIndex = index; //报销列表中的index
      this.bxTypeIndex = typeIndex; //被选择报销列表数组index
    },
    //保存报销类型
    saveBxType(data) {
      let _this = this;
      if (_this.bxTypeIndex == "1") {
        this.showBxTypePicker = false;
        this.$set(
          this.reimburseList[this.typeIndex],
          "firstTypeName",
          data.dictName
        );
        this.$set(
          this.reimburseList[this.typeIndex],
          "firstType",
          data.dictCode
        );
        this.$set(this.reimburseList[this.typeIndex], "secondTypeName", "");
        this.$set(this.reimburseList[this.typeIndex], "secondType", "");
        this.$set(this.reimburseList[this.typeIndex], "thirdTypeName", "");
        this.$set(this.reimburseList[this.typeIndex], "thirdType", "");
        _this.getBxType(data.dictCode, 2);
      } else if (_this.bxTypeIndex == "2") {
        this.showBxTypePicker = false;
        this.$set(
          this.reimburseList[this.typeIndex],
          "secondTypeName",
          data.dictName
        );
        this.$set(
          this.reimburseList[this.typeIndex],
          "secondType",
          data.dictCode
        );
        this.$set(this.reimburseList[this.typeIndex], "thirdTypeName", "");
        this.$set(this.reimburseList[this.typeIndex], "thirdType", "");
        _this.getBxType(data.dictCode, 3);
      } else {
        this.showBxTypePicker = false;
        this.$set(
          this.reimburseList[this.typeIndex],
          "thirdTypeName",
          data.dictName
        );
        this.$set(
          this.reimburseList[this.typeIndex],
          "thirdType",
          data.dictCode
        );
      }
    },
    //项目信息
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    setProject(data) {
      //获取所属项目
      let _this = this;
      if (data != "") {
        console.log(data, "data");
        _this.propertyData.projectCode = data.id;
        _this.propertyData.projectName = data.name;
        _this.propertyData.projectOrgan = data.projectCompany;
        _this.marketArchive = data.marketArchive;
        _this.technologyArchive = data.technologyArchive;
        this.firstContact = data.firstContact;
        if (this.specialType == "1") {
          _this.reimburseList.forEach((item) => {
            _this.$set(item, "firstType", "");
            _this.$set(item, "firstTypeName", "");
            _this.$set(item, "secondType", "");
            _this.$set(item, "secondTypeName", "");
            _this.$set(item, "thirdType", "");
            _this.$set(item, "thirdTypeName", "");
          });
        }
        _this.getIncomeAndExpenses(data.id); //获取项目的收支情况
        _this.getCostInfo(data.id);
      }
      this.showItemPicker = false;
    },
    getIncomeAndExpenses(id) {
      let _this = this;

      _this.$api.finance.reimburse
        .reimburseIncomeAndExpenses({
          projectId: id,
          dateUnitType: "all",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.incomeAndExpenses = res.data;

            if (
              res.data.contractAmount != null &&
              parseFloat(res.data.contractAmount) > 0 &&
              res.data.income != null &&
              parseFloat(res.data.income) > 0
            ) {
              let percent = (
                (parseFloat(res.data.income) /
                  parseFloat(res.data.contractAmount)) *
                100
              ).toFixed(2);
              this.$set(
                _this.incomeAndExpenses,
                "income",
                res.data.income + " (" + percent + "%" + ")"
              );
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //项目id获取成本信息I
    getCostInfo(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .getCostInfo({
          projectId: id,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.marketPercent = res.data.marketPercent
              ? Number(res.data.marketPercent).toFixed(2)
              : ""; // 营销成本比例
            _this.marketingCost = res.data.marketingCost
              ? Number(res.data.marketingCost).toFixed(2)
              : ""; // 营销成本
            _this.marketingCostTotal = res.data.marketingCostTotal
              ? Number(res.data.marketingCostTotal).toFixed(2)
              : ""; // 累计营销成本
            _this.remainMarketingCost = res.data.remainMarketingCost
              ? Number(res.data.remainMarketingCost).toFixed(2)
              : ""; //剩余营销成本

            _this.technologyPercent = res.data.technologyPercent
              ? Number(res.data.technologyPercent).toFixed(2)
              : ""; //技术成本比例
            _this.technicalCost = res.data.technicalCost
              ? Number(res.data.technicalCost).toFixed(2)
              : ""; // 技术成本
            _this.technicalCostTotal = res.data.technicalCostTotal
              ? Number(res.data.technicalCostTotal).toFixed(2)
              : ""; // 累计技术成本
            _this.remainTechnicalCost = res.data.remainTechnicalCost
              ? Number(res.data.remainTechnicalCost).toFixed(2)
              : ""; // 剩余技术成本

            _this.receptionPercent = res.data.receptionPercent
              ? Number(res.data.receptionPercent).toFixed(2)
              : ""; //招待成本比例
            _this.receptionCost = res.data.receptionCost
              ? Number(res.data.receptionCost).toFixed(2)
              : ""; // 招待成本
            _this.receptionCostTotal = res.data.receptionCostTotal
              ? Number(res.data.receptionCostTotal).toFixed(2)
              : ""; // 累计已招待成本
            _this.remainReceptionCost = res.data.remainReceptionCost
              ? Number(res.data.remainReceptionCost).toFixed(2)
              : ""; // 剩余招待成本

            _this.bidCostTotal = res.data.bidCostTotal
              ? Number(res.data.bidCostTotal).toFixed(2)
              : ""; // 累计投标成本
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getMoneyDetail(name) {
      //跳转项目支出,收入详情
      let _this = this;
      _this.pickerType = name;
      _this.getProjectMoneyDetail();
      _this.showProjectMoneyPicker = true;
    },
    getProjectMoneyDetail() {
      //项目支出或收入详情
      let _this = this;
      _this.$api.project
        .reimburseProjectExpensesDetail(_this.pickerType, 1, 200, {
          dateUnitType: "all",
          projectId: _this.propertyData.projectCode,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.moneydetailList = res.data.list;
          } else {
            _this.$toast(res.msg);
          }
          _this.refreshing = true;
        })
        .catch((err) => {
          _this.refreshing = true;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        _this.btnLoading = true;
        let params = this.propertyData;
        params.detailList = this.reimburseList;
        params.projectId = params.projectCode;
        params.totalAmount = parseFloat(this.totalAmount).toFixed(2);
        params.reimburseType = this.specialType;
        _this.$api.finance.reimburse
          .update(this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    validate() {
      let _this = this;
      console.log(this.propertyData,'this.propertyDatathis.propertyData')
      if (this.propertyData.receiptsNumber == "" || !this.propertyData.reimburseUidName) {
        _this.$toast("请完善表单信息");
        return false;
      }
      console.log(this.reimburseList.length,this.reimburseList[1])
      if (this.reimburseList.length > 0) {
        for (var i = 0; i <=this.reimburseList.length-1; i++){
          if (
            this.reimburseList[i].thirdType == "" ||
            this.reimburseList[i].amount == "" ||
            this.reimburseList[i].instruction == ""
          ) {
            _this.$toast("请完善表单信息");
            return false;
          }
          if(this.reimburseList[i]&&this.reimburseList[i].firstType!=this.reimburseList[0].firstType){
            _this.$toast(`第${i+1}个报销类别跟第1个报销类别不一致,请重新选择!`);
            return false;
          }
        } 
      }
      return true;
    },
  },
  computed: {
    bxTypeListBase(){
      let _this=this;
      console.log(_this.bxTypeIndex,this.bxTypeList)
      let arr=_this.reimburseList[0].firstType&&_this.reimburseList.length>1&&_this.bxTypeIndex==1?this.bxTypeList.filter(item =>item.dictCode== _this.reimburseList[0].firstType):this.bxTypeList;
      return arr;
    },
    totalAmount() {
      //报销总金额
      let _this = this,
        total = 0;
      this.reimburseList.forEach(function (item) {
        total += Number(item.amount ? item.amount : 0);
      });
      return parseFloat(total).toFixed(2);
    },
    ...mapState(["showLoad", "userinfo"]),
    isZL(){//是否是助理角色
      let index = this.userinfo.roleIds.findIndex(item=>item == '111' || item == '112')
      return index>=0
    },
  },
};
</script>
<style lang="less">
.reimbursementPage {
  width: 100%;
  background-color: #f6f6f6;
  padding-bottom: 60px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #f6f6f6;
    .van-popup__close-icon--top-right {
      top: 5px;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .delectBtn {
    width: 50%;
  }
  #searchHeight {
    text-align: left;
  }

  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
    }
    p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 20px;
      background: #2581d6;
      top: 13px;
      left: 16px;
    }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }
  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .projectIncome {
    position: relative;
    .xmsrStyle {
      .van-cell__value {
        width: 50%;
      }
    }
    .ggInput.xmsrStyle.van-cell::after {
      content: none;
    }
  }
  .changeW.projectIncome {
    span.percent {
      position: absolute;
      width: 35px;
      top: 13px;
      right: 45px;
      color: #969799;
      font-size: 15px;
      text-align: right;
    }
  }
  .claimItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    position: relative;
    .delect {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
    }
  }
  .baseNone {
    .van-cell__title {
      span {
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>